import React, {memo} from 'react';
import BenutzerManagement from "../Components/BenutzerManagement/BenutzerManagement";

function BenutzerManagementPage() {
    return (
        <>
            <br/>
            <br/>
            <BenutzerManagement/>
        </>
    )
}

export default memo(BenutzerManagementPage);